module.exports = __webpack_public_path__ + "static/media/frame_49.da39e436.jpg";